<template>
    <div>
        <van-nav-bar    left-text="返回" @click-left="back"    left-arrow/>
        <div class='pt46'>
            <van-cell > 
                <template slot="title" >
                    <van-icon name="stop" style="vertical-align:middle"  color='#0076bf' />
                    <span class="custom-title" style="vertical-align:middle;padding-left:10px">基础数据来源:</span>
                    <img src="../../../static/qxzx.png" style="vertical-align:middle;padding-left:15px" width='80' alt="">
                </template>
            </van-cell>
            <van-cell > 
                <template slot="title" >
                    <van-icon name="stop" style="vertical-align:middle"  color='#0076bf' />
                    <span class="custom-title" style="vertical-align:middle;padding-left:10px">数据处理服务:</span>
                    <img src="../../../static/jjr.png" style="vertical-align:middle;padding-left:15px" width='80' alt="">
                </template>
            </van-cell>
            <van-cell class='addressLink' @click='toPosition'  is-link> 
                <template slot="title" >
                    <van-icon name="stop" style="vertical-align:middle"  color='#0076bf' />
                    <span class="custom-title" style="vertical-align:middle;padding-left:10px">地址:</span>
                    <van-notice-bar style='width:70%;display:inline-block;height:20px;top:8px' background="rgba(0,0,0,0)"   color='#2c3e50' :text="phonePosition.address"/>
                </template>
            </van-cell>
            <van-cell title="查询维度:"  @click="isShowDimension = true" :value='search_time_name' is-link />
            <van-cell title="查询年份(单选):" v-show="isShowYearList" :value='search_year_name'  @click="isShowYear = true" is-link />
            <van-cell title="查询年份(多选):" v-show="!isShowYearList"  :value='search_year_more_name' @click="isShowYear_more = true" is-link />
            <van-cell title="查询月份:" v-show="isShowMonthList" :value='search_month_name'  @click="isShowMonth = true" is-link />
            <van-cell title="查询属性:" v-show="isShowAttrList" :value='param_name'  @click="isShowAttribute = true" is-link /> 
            <van-cell title="查询属性(高阶):" v-show="!isShowAttrList" :value='param_name'  @click="isShowAttribute_more = true" is-link /> 
            <div ref="dom" style="height: 430px;position: relative !important;text-align:center;" v-show="showChar"></div>
            <div v-show="noData" style="height: 310px;position: relative !important;text-align:center;">暂无数据</div>
            <!-- <div id="gdMap_data" ref='amap'></div>  -->
        </div>


        <!-- 选择维度 -->
            <van-popup v-model="isShowDimension" get-container="body">
                <van-radio-group v-model="search_time" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in dimensionList" :key="index" :title="item.name" clickable @click="changeDimension(item)">
                            <van-radio slot="right-icon" :name="item.value" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <!-- 选择年份(单) -->
            <van-popup v-model="isShowYear" get-container="body">
                <van-radio-group v-model="search_year" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in yearList" :key="index" :title="item.label" clickable @click="changeYear(item)">
                            <van-radio slot="right-icon" :name="item.value" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <!-- 选择年份(多选) -->        
            <van-popup v-model="isShowYear_more" get-container="body" style="width:200px">
                <van-checkbox-group v-model="search_year_more" @change='changeYearMore'>
                    <van-cell-group>
                        <van-cell
                        v-for="(item, index) in yearList"
                        clickable
                        :key="index"
                        :title="item.label"
                        @click="yearToggle(index)"
                        >
                        <van-checkbox
                            :name="item.value"
                            ref="yearMoreList"
                            slot="right-icon"
                        />
                        </van-cell>
                    </van-cell-group>
                    </van-checkbox-group>
            </van-popup>

            <!-- 选择月份 -->
            <van-popup v-model="isShowMonth" get-container="body">
                <van-radio-group v-model="search_month" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in monthList" :key="index" :title="item.label" clickable @click="changeMonth(item)">
                            <van-radio slot="right-icon" :disabled='item.type' :name="item.value" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <!-- 查询属性 -->
            <van-popup v-model="isShowAttribute" get-container="body">
                <van-radio-group v-model="param" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in Attribute" :key="index" :title="item" clickable @click="changeAttribute(item,index)">
                            <van-radio slot="right-icon" :disabled='item.type' :name="index" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <!-- 查询属性(高阶) -->
            <van-popup v-model="isShowAttribute_more" get-container="body">
                <van-radio-group v-model="param" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in attributeList" :key="index" :title="item" clickable @click="changeAttribute(item,index)">
                            <van-radio slot="right-icon" :disabled='item.type' :name="index" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>











    </div>
</template>
<script>

import {getWeatherCount,getCountDay,getCountMonth,getWeatherCountHistory} from '@/request/data'
import {mapState} from 'vuex'
import echarts from 'echarts'
import tdTheme from '../../components/charts/theme.json'
export default {
    name:'dataStatistics',
    data() {
        return {
            isShowDimension:false,
            isShowYear:false,
            isShowYear_more:false,
            isShowMonth:false,
            isShowAttribute:false,
            isShowYearList:true,
            isShowMonthList:true,
            isShowAttrList:true,
            isShowAttribute_more:false,
            weatherUuid:'',
            dimensionList:[
                {value:1,name:'日'},
                {value:2,name:'月'},
                {value:3,name:'年'},
                {value:4,name:'高阶查询'},
            ],
            search_time:1,
            search_time_name:'日',
            search_year:'',
            search_year_name:'',
            search_year_more:[],
            search_year_more_name:'',
            search_month:0,
            search_month_name:'全年',
            weatherInfo_history:{
                lat:'',
                lon:'',
                line:'',
                query_type:'',    
                query_year:[],
                query_month:'',
            },
             DavisAttribute:[
                {name:'barometer'},
                {name:'temp_out_avg'},
                {name:'wind_avg'},
                {name:'wind_direction'},
                {name:'humi_out'},
                {name:'rain'},
                {name:'sra_avg'},
                {name:'uv_index_grade'},
                {name:'et'},
            ],
            pointAttributeList:[ "降雨量(mm)","大气温度(°C)", "数字气压(hpa)","风速(m/s)", "日照(W/m2)"],
            advancedAttributeList:['年积温(°C)'],
            WeatherName:[],
            Name:[],
            Attribute:[],
            attributeList:[],
            Lines:[],
            Type_ids:[],
            param:'',
            param_name:'',
            dom: null,
            noData:false,
            showChar:false,
            option:{
                title: {
                    text: ''
                },
                tooltip: {
                    confine:true,//该属性为true让tooltip不会超过父标签而显示不全
                    trigger: 'axis',    
                                    
                },                
                dataZoom: [
                    {                        
                        type: 'slider',
                        xAxisIndex: [0],
                        filterMode: 'filter',
                        bottom:'10%'
                    },
                ],
                legend: {
                    data:[]
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '6%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        //saveAsImage: {},
                        magicType: {
                        type: ['line', 'bar'],
                            // show: false
                        },
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    type: 'value',
                },
                series: [],
            },
            option2:{
                title: {
                    text: ''
                },
                tooltip: {
                    confine:true,//该属性为true让tooltip不会超过父标签而显示不全
                    // trigger: 'axis'
                },
                legend: {
                    data:[]
                },          
                radar: {            
                    name: {
                        textStyle: {
                            color: '#fff',
                            backgroundColor: '#999',
                            borderRadius: 3,
                            padding: [3, 5]
                        }
                    },
                    indicator: [ ],
                    center: ['50%', '45%'],
                    radius: 120
                },          
                series: [],
            },
            
        }
    },
    computed: {
        ...mapState(['phonePosition']),
        yearList(){
            let myDate = new Date();
            let tYear = myDate.getFullYear();
            this.search_year = tYear
            this.search_year_name = tYear + '年'
            let arr = []
            for (let i = 0; i < 10; i++) {
                let obj = {}
                obj.value = tYear - i
                obj.label = tYear - i + '年'
                arr.push(obj)
            }      
            return arr
        },
        monthList(){
            let arr = []
                if (this.search_time ==1) {
                    for (let i = 0; i < 13; i++) {
                        let obj = {}
                        if (i ==0 ) {
                            obj.value = i
                            obj.label = '全年'                           
                        }else{
                            obj.value = i
                            obj.label = i + '月'                            
                        }
                        arr.push(obj)
                    }
                    return arr                    
                }else if (this.search_time ==3) {
                    for (let i = 1; i < 13; i++) {
                        let obj = {}                        
                        obj.value = i
                        obj.label = i + '月'                                              
                        arr.push(obj)
                    }
                    return arr
                }                
        }
    },
    mounted() {
         //循环属性
        for (let i = 0; i < 5; i++) {
        this.Lines.push('line'+(i+1))
        this.Attribute = this.pointAttributeList
        }
        this.param = 0
        this.param_name = this.Attribute[this.param]
        this.getChart()
       
    },
    methods: {
        changeDimension(item){//改变维度           
            this.param_name = this.Attribute[0]
            this.search_time = item.value
            this.search_time_name = item.name            
            this.isShowAttrList = true
            let arr =  this.yearList
            console.log(arr)
            switch (this.search_time) {
                case 1:
                    this.isShowYearList = true
                    this.isShowMonthList = true
                    this.search_month = this.monthList[0].value
                    this.search_month_name = this.monthList[0].label
                    this.search_year =  this.yearList[0].value
                    this.search_year_name =  this.yearList[0].label
                    break;
                case 2:
                    this.isShowYearList = false
                    this.isShowMonthList = false                    
                    this.search_year_more = []
                    this.search_year_more = [arr[0].value,arr[1].value,arr[2].value]
                    this.search_year_more_name = `${arr[0].label},${arr[1].label},+1...`
                    break;
                case 3:
                    this.isShowYearList = false
                    this.isShowMonthList = true                    
                    this.search_month = this.monthList[0].value
                    this.search_month_name = this.monthList[0].label                   
                    this.search_year_more = []
                    this.search_year_more = [arr[0].value,arr[1].value,arr[2].value]
                    this.search_year_more_name = `${arr[0].label},${arr[1].label},+1...`                    
                    break;
                case 4:
                    this.isShowYearList = true
                    this.isShowMonthList = false
                    this.isShowAttrList = false
                    this.attributeList = this.advancedAttributeList
                    this.param = 0
                    this.param_name = this.advancedAttributeList[0]
                    this.search_year =  this.yearList[0].value
                    this.search_year_name =  this.yearList[0].label
                    break;
            
                default:
                    break;
            }
            this.getChart()
            this.isShowDimension = false

        },
        changeYear(item){//改变年份
            this.search_year = item.value
            this.search_year_name = item.label
            this.isShowYear = false
            this.getChart()            
        },
        changeYearMore(item){
            console.log(item.length,this.search_year_more_name)
            this.search_year_more_name = ''
            if (item.length > 2) {
                this.search_year_more_name = `${item[0]}年,${item[1]}年,+${item.length-2}...`
            }else{
                switch (item.length) {
                    case 0:
                        this.search_year_more_name = ''
                        break;
                    case 1:
                        this.search_year_more_name = item[0]
                        break;
                    case 2:
                        this.search_year_more_name = `${item[0]},${item[1]}`
                        break;                
                    default:
                        break;
                }
                //  
            }
            this.getChart()
        },
        getChart: function () {//获得图表数据并展示
            this.spinShow = true
            this.option.series = [] 
            this.option.legend.data = []
            this.option.legend.bottom = '0'
            this.option.xAxis.data = []
        
            this.weatherInfo_history.lat = this.phonePosition.lat
            this.weatherInfo_history.lon = this.phonePosition.lon
            this.weatherInfo_history.line = this.Lines[this.param]            
            this.weatherInfo_history.query_type = this.search_time
            if (this.search_time == 1 || this.search_time == 4) {
               this.weatherInfo_history.query_year = []
              this.weatherInfo_history.query_year.push(this.search_year)              
            }else{
              this.weatherInfo_history.query_year = this.search_year_more
            }

            this.weatherInfo_history.query_month = this.search_month    
            console.log(this.weatherInfo_history)        
            this.getWeatherCountHistory(this.weatherInfo_history)
        },
        getWeatherCountHistory(data){//经纬度查询
        this.noData = false
        getWeatherCountHistory(data).then(res=>{
            this.spinShow =false
            this.showChar = true
            if (res.data.code == 0) {
                    if (this.search_time == '3') {//年维度柱状
                        this.option.toolbox.feature.magicType.type = 'bar'
                    }else{
                        this.option.toolbox.feature.magicType.type = ['line', 'bar']
                    }
                    
                    if (this.search_time == 4) {//高阶查询
                        this.option.title.text = this.attributeList[this.param].split('(')[0];
                        this.option.series = this.getSeries(JSON.parse(JSON.stringify(res.data.data.weather)),JSON.parse(JSON.stringify(res.data.data.name))) 
                        this.option.legend.data = JSON.parse(JSON.stringify(res.data.data.name))
                        this.option.xAxis.data = JSON.parse(JSON.stringify(res.data.data.time))                      
                        this.$nextTick(() => {
                            this.dom = echarts.init(this.$refs.dom,'tdTheme');
                            this.dom.setOption(this.option,true);                            
                        })                        
                    }else{
                        this.option.title.text = this.Attribute[this.param].split('(')[0];
                        this.option.series = this.getSeries(JSON.parse(JSON.stringify(res.data.data.weather)),JSON.parse(JSON.stringify(res.data.data.name))) 
                        this.option.legend.data = JSON.parse(JSON.stringify(res.data.data.name))
                        this.option.xAxis.data = JSON.parse(JSON.stringify(res.data.data.time))
                        this.$nextTick(() => {
                            this.dom = echarts.init(this.$refs.dom,'tdTheme');
                            this.dom.setOption(this.option,true);                            
                        })
                    }                    
                
            }
            }).catch(err=>{

            })

        },
        getSeries(seriesData,legendData){//处理图表数据      
            var series=[];
            for(var i = 0;i<legendData.length;i++){
                let t ='line'
                let w = ''
                if (this.search_time == 3) {
                t = 'bar'
                w = 20
                }
                series.push({
                name: legendData[i],
                type: t,
                barWidth: w,
                data: seriesData[i]
                });
            }            
            return series;
        },
        changeMonth(item){    
            console.log(item)
            this.search_month = item.value
            this.search_month_name = item.label
            this.isShowMonth = false
            this.getChart()
        },
        changeAttribute(item,index){
            console.log(item,index)
            this.param = index
            this.param_name = item
            this.isShowAttribute = false
            this.isShowAttribute_more = false
            this.getChart()
        },
        yearToggle(index){            
            this.$refs.yearMoreList[index].toggle();
        },  
        toPosition(){
            this.$router.push({name:'position'})
        },
        back(){
            this.$router.back(-1)
        },
        
    },
}
</script>
<style  scoped>
#gdMap_data{width:100%;height:250px}
.vbtn{width:95%;margin: 15px auto}
.addressLink .van-cell__right-icon{margin-top:8px}
</style>